import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const GuitarIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Group 29613571">
        <path id="Vector" d="M9.00009 13.5H7.5V15.0001H9.00009V13.5Z" fill={fillColor || '#F6F6F7'} />
        <path
          id="Vector_2"
          d="M11.9996 13.4993H10.4995V14.9994H8.99946V16.4995H7.49937V14.9994H5.99928V13.4993H7.49937V11.9992H8.99946V10.4992H10.4995V7.49933H11.9996V4.49951H8.99981V5.9996H7.49973V8.99942H5.99964V10.4995H1.50009V11.9996H0V19.4993H1.50009V20.9994H3.00018V22.4995H4.50027V23.9996H12V22.4995H13.5001V17.9996H15.0002V16.4995H18V14.9994H19.5001V11.9996H16.5003V13.4997H13.5004V11.9996H12.0004V13.4997L11.9996 13.4993ZM7.49973 20.9991H5.99964V19.499H4.49955V17.9989H2.99946V16.4988H4.49955V17.9989H5.99964V19.499H7.49973V20.9991ZM8.99981 22.4991V20.9991H10.4999V22.4991H8.99981ZM11.9996 19.4993H10.4995V17.9992H11.9996V19.4993Z"
          fill={fillColor || '#F6F6F7'}
        />
        <path id="Vector_3" d="M10.5001 11.9995H9V13.4996H10.5001V11.9995Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_4" d="M14.9998 10.5015H13.4998V12.0016H14.9998V10.5015Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_5" d="M11.9998 10.5015H10.4998V12.0016H11.9998V10.5015Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_6" d="M16.4998 9.00098H14.9998V10.5011H16.4998V9.00098Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_7" d="M13.4998 9.00098H11.9998V10.5011H13.4998V9.00098Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_8" d="M17.9996 7.50049H16.4995V9.00058H17.9996V7.50049Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_9" d="M14.9998 7.50049H13.4998V9.00058H14.9998V7.50049Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_10" d="M19.4998 6H17.9998V7.50009H19.4998V6Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_11" d="M16.4998 6H14.9998V7.50009H16.4998V6Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_12" d="M17.9998 4.49951H16.4998V5.9996H17.9998V4.49951Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_13" d="M17.9998 1.50098H16.4998V3.00107H17.9998V1.50098Z" fill={fillColor || '#F6F6F7'} />
        <path
          id="Vector_14"
          d="M20.9996 0.000488281V1.50058H19.4998V3.00031H17.9998V4.5004H19.4998V6.00049H22.4997V4.5004H23.9998V0.000488281H20.9996Z"
          fill={fillColor || '#F6F6F7'}
        />
        <path id="Vector_15" d="M19.4998 0.000488281H17.9998V1.50058H19.4998V0.000488281Z" fill={fillColor || '#F6F6F7'} />
      </g>
    </svg>
  );
};

export { GuitarIcon };
